// The `/live-stream` route's flag gate, extracted from the route's `beforeLoad`
// so a unit test can reach it. The route file itself is coverage-excluded
// (`src/routes/**`), and its only other proof would be an authenticated
// Playwright spec — which skips in CI (`TEST_USERNAME` unset, #100). This is a
// PRINCIPLES §3 default-deny control: nav-hiding is NOT a gate (the URL is
// reachable directly), and `provision()` behind it creates a BILLABLE Cloudflare
// Live Input (decision 3).

import { redirect } from '@tanstack/react-router';

export function assertLiveStreamEnabled(flags: Record<string, boolean>): void {
	if (!flags['live-stream']) {
		throw redirect({ to: '/live-in-club' });
	}
}

/**
 * The full gate: evaluate the flags, then assert. A FAILED evaluation is
 * treated exactly like a dark flag — redirect, not error boundary — because
 * default-deny must hold on every path: an errored flag service must not
 * strand the Manager on a broken page NOR leak the billable surface.
 */
export async function gateLiveStreamRoute(
	fetchFlags: () => Promise<Record<string, boolean>>,
): Promise<void> {
	let flags: Record<string, boolean>;
	try {
		flags = await fetchFlags();
	} catch {
		throw redirect({ to: '/live-in-club' });
	}
	assertLiveStreamEnabled(flags);
}
